import React, { useEffect } from "react";
import { useLoader } from "../context/LoaderContext";
import { fetchGalleryBanner, fetchGalleryData } from "../api/GalleryApi";
import { dynamicFailed } from "../hooks/useToast";
import { useGalleryBannerContext } from "../context/GalleryBannerContext";
import { useGalleryImageContext } from "../context/GalleryImageContext";
import GalleryBanner from "../components/gallery/GalleryBanner";
import GalleryImage from "../components/gallery/GalleryImage";
import { useEventContext } from "../context/EventContext";
import { fetchEventData } from "../api/EventApi";

const GalleryView = () => {
  const { setLoading } = useLoader();
  const { galleryBannerData, setGalleryBannerData } = useGalleryBannerContext();
  const { galleryImageData, setGalleryImageData } = useGalleryImageContext();
  const { eventData, setEventData } = useEventContext();

  useEffect(() => {
    if (
      galleryBannerData.length === 0 ||
      galleryImageData.length === 0 || 
      eventData.length === 0
    ) {
      Promise.all([fetchGalleryBanner(), fetchGalleryData(), fetchEventData()])
        .then(([GalleryBannerData, GalleryImageData, eventData]) => {
          setGalleryBannerData(GalleryBannerData);
          setGalleryImageData(GalleryImageData);
          setEventData(eventData);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          dynamicFailed("Server Error");
        });
    }
  }, [eventData.length, galleryBannerData.length, galleryImageData.length, setEventData, setGalleryBannerData, setGalleryImageData, setLoading]);
  return (
    <>
      <GalleryBanner galleryBannerData={galleryBannerData} />
      <GalleryImage />
    </>
  );
};

export default GalleryView;
